import script from "./ExpenseForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpenseForm.vue?vue&type=script&setup=true&lang=js"

import "./ExpenseForm.vue?vue&type=style&index=0&id=28c58d08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28c58d08"]])

export default __exports__